import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import Image from "../components/Image";

import UserPanel from "../components/UserPanel";
import {
  getChatData,
  getChatUserMessagesAction,
  sendMessageAction,
  changeCurrentChatUserID,
} from "../actions/chatActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faPlusCircle,
  faPaperPlane,
  faCommentSlash,
  faComments,
} from "@fortawesome/free-solid-svg-icons";

const Messages = ({
  getChatData,
  chatUsers,
  currentUserData,
  getChatUserMessagesAction,
  currentChatMessages,
  sendMessageAction,
  currentChatUserID,
  changeCurrentChatUserID,
  // allUsers,
}) => {
  const { t } = useTranslation();

  const [messageText, setMessageText] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const messagesRef = useRef(null);

  const allUsers = [
    { id: 1, first_name: "ტესტ", last_name: "იუზერი", profile_pic: "" },
    { id: 2, first_name: "ტესტ", last_name: "იუზერი", profile_pic: "" },
    { id: 3, first_name: "ტესტ", last_name: "იუზერი", profile_pic: "" },
  ];

  useEffect(() => {
    getChatData();
    // თუ გაქვს ექშენი ყველა იუზერისთვის:
    // getAllUsersAction();
  }, []);

  useLayoutEffect(() => {
    if (messagesRef.current) {
      const container = messagesRef.current;
      container.scrollTop = container.scrollHeight;
    }
  }, [currentChatMessages]);

  useEffect(() => {
    getChatData();
  }, []);
  useEffect(() => {
    if (currentChatUserID) {
      getChatUserMessagesAction(currentChatUserID);
    }
  }, [currentChatUserID]);

  const renderAllUsersModal = () => {
    if (!isModalOpen) return null;

    return (
      <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
        <div
          className="users-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <h3>{t("choose_user")}</h3>
          <div className="all-users-list">
            {/* აქ ვიყენებთ allUsers-ს რომელიც პროპსებიდან მოდის */}
            {allUsers &&
              allUsers.map((user) => (
                <div
                  key={user.id}
                  className="user-select-item"
                  onClick={() => {
                    changeCurrentChatUserID(user.id);
                    setIsModalOpen(false);
                  }}
                >
                  <Image src={user.profile_pic} alt="" />
                  <p>
                    {user.first_name} {user.last_name}
                  </p>
                </div>
              ))}
          </div>
          <button onClick={() => setIsModalOpen(false)}>{t("close")}</button>
        </div>
      </div>
    );
  };

  const renderChatUsers = () => {
    if (chatUsers && currentUserData) {
      return chatUsers.map((user) => {
        return (
          <div
            key={user.id}
            className="user-img-for-chat"
            onClick={() => {
              changeCurrentChatUserID(user.id);
            }}
          >
            <Image src={user.profile_pic} alt="" />
            <p>
              {user.first_name} {user.last_name.substring(0, 2).toUpperCase()}.
            </p>
            {user.has_unseen_conversation ? <span>New!</span> : <></>}
          </div>
        );
      });
    }
  };

  const renderMessages = () => {
    if (currentChatMessages.length > 0 && currentUserData) {
      return currentChatMessages.map((message, i) => {
        if (message.sender_id === currentUserData.id) {
          return (
            <div className="messages-lane">
              <p key={message.content + i} className="me">
                {message.content}
              </p>
            </div>
          );
        } else {
          return (
            <div className="messages-lane">
              <p key={message.content + i} className="other-user">
                {message.content}
              </p>
            </div>
          );
        }
      });
    } else {
      return (
        <div className="empty-conversation">
          <FontAwesomeIcon icon={faComments} />
          <p>{t("start a conversation")}</p>
        </div>
      );
    }
  };

  const handleSendMessage = () => {
    if (messageText !== "") {
      sendMessageAction({
        receiver_id: currentChatUserID,
        sender_id: currentUserData.id,
        content: messageText,
      });
      setMessageText("");
    }
  };
  return (
    <div className="userpanel-container">
      <UserPanel />
      <div className="userpanel-screen-main-container">
        <div className="user-message-container">
          {renderAllUsersModal()}
          <div className="user-list-container">
            <div
              className="add-user-in-chat"
              onClick={() => setIsModalOpen(true)}
            >
              <FontAwesomeIcon icon={faPlus} />
              <p>{t("add")}</p>
            </div>

            {renderChatUsers()}
          </div>

          <div className="read-send-message-container">
            <div ref={messagesRef} className="read-message">
              {renderMessages()}
            </div>

            <div className="send-message-parent-container">
              <textarea
                onChange={(e) => setMessageText(e.target.value)}
                placeholder={t("write message text")}
                value={messageText}
              ></textarea>

              <button onClick={() => handleSendMessage()} type="submit">
                <FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    chatUsers: state.chat.chatUsers,
    allUsers: state.chat.allUsers,
    currentUserData: state.userData.userData,
    currentChatMessages: state.chat.currentChatMessages,
    currentChatUserID: state.chat.currentChatUserID,
  };
};

export default connect(mapStateToProps, {
  getChatData,
  getChatUserMessagesAction,
  sendMessageAction,
  changeCurrentChatUserID,
  // getAllUsersAction, // დაამატე თუ გაქვს ბექენდიდან წამოსაღებად
})(Messages);
